import { SvgType } from './types'

export default function CheckboxOn({ fill, style, size, viewBox }: SvgType) {
  return (
    <svg
      width={size}
      height={size}
      style={style}
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x={3} y={3} width={18} height={18} rx={2} fill={fill} />
      <path
        d="M15.0408 9L10.5601 13.2013L8.95918 11.7002L8 12.5996L10.5601 15L16 9.89936L15.0408 9Z"
        fill="white"
      />
    </svg>
  )
}
